// columns 12, aspect ratio 16/9
const IMAGE_SIZES_COLUMNS_12_169 = {
  small: { width: 327, height: 184, aspectRatio: '16/9' },
  medium: { width: 672, height: 378, aspectRatio: '16/9' },
  large: { width: 1200, height: 675, aspectRatio: '16/9' }
}

// columns 12, aspect ratio 5/2
const IMAGE_SIZES_COLUMNS_12_52 = {
  small: { width: 327, height: 131, aspectRatio: '5/2' },
  medium: { width: 672, height: 269, aspectRatio: '5/2' },
  large: { width: 1200, height: 480, aspectRatio: '5/2' }
}

// columns 12, aspect ratio 5/2 on desktop > 16/9 on tablet and mobile
const IMAGE_SIZES_COLUMNS_12_5269 = {
  small: { width: 327, height: 184, aspectRatio: '16/9' },
  medium: { width: 672, height: 378, aspectRatio: '16/9' },
  large: { width: 1200, height: 480, aspectRatio: '5/2' }
}

// columns 12, aspect ratio 5/2 on desktop, 16/9 on mobile -- NEW GRID.

const IMAGE_SIZES_COLUMNS_12_RATIO_52_52_169 = {
  small: { width: 344, height: 193, aspectRatio: '16/9' },
  medium: { width: 690, height: 276, aspectRatio: '5/2' },
  large: { width: 1416, height: 566, aspectRatio: '5/2' }
}

// columns 6, aspect ratio 1/1 on desktop, 5/2 on tablet and mobile -- NEW GRID.

const IMAGE_SIZES_COLUMNS_6_RATIO_11_52_169 = {
  small: { width: 344, height: 193, aspectRatio: '16/9' },
  medium: { width: 690, height: 276, aspectRatio: '5/2' },
  large: { width: 576, height: 576, aspectRatio: '1/1' }
}

// columns 12, aspect ration 2/1 -- NEW GRID.
const IMAGE_SIZES_COLUMNS_12_21 = {
  small: { width: 392, height: 196, aspectRatio: '2/1' },
  medium: { width: 786, height: 393, aspectRatio: '2/1' },
  large: { width: 1608, height: 804, aspectRatio: '2/1' }
}

const IMAGE_SIZES_COLUMNS_10_169 = {
  small: { width: 327, height: 184, aspectRatio: '16/9' },
  medium: { width: 672, height: 378, aspectRatio: '16/9' },
  large: { width: 990, height: 556, aspectRatio: '16/9' }
}

// columns 10, aspect ration 2/1 -- NEW GRID.
const IMAGE_SIZES_COLUMNS_10_21 = {
  small: { width: 344, height: 127, aspectRatio: '2/1' },
  medium: { width: 690, height: 345, aspectRatio: '2/1' },
  large: { width: 1176, height: 588, aspectRatio: '2/1' }
}

// columns 6, aspect ratio 1/1
const IMAGE_SIZES_COLUMNS_6_11 = {
  small: { width: 327, height: 327, aspectRatio: '1/1' },
  medium: { width: 312, height: 312, aspectRatio: '1/1' },
  large: { width: 576, height: 576, aspectRatio: '1/1' }
}
// columns 6, aspect ratio 4/3
const IMAGE_SIZES_COLUMNS_6_43 = {
  small: { width: 436, height: 327, aspectRatio: '4/3' },
  medium: { width: 416, height: 312, aspectRatio: '4/3' },
  large: { width: 768, height: 576, aspectRatio: '4/3' }
}
// columns 6, aspect ratio 3/4
const IMAGE_SIZES_COLUMNS_6_34 = {
  small: { width: 327, height: 436, aspectRatio: '3/4' },
  medium: { width: 312, height: 416, aspectRatio: '3/4' },
  large: { width: 576, height: 768, aspectRatio: '3/4' }
}
// columns 6, aspect ratio 16/9
const IMAGE_SIZES_COLUMNS_6_169 = {
  small: { width: 327, height: 184, aspectRatio: '16/9' },
  medium: { width: 672, height: 378, aspectRatio: '16/9' },
  large: { width: 696, height: 392, aspectRatio: '16/9' }
}

// columns 5, aspect ratio 3/4
const IMAGE_SIZES_COLUMNS_5_34 = {
  small: { width: 327, height: 436, aspectRatio: '3/4' },
  medium: { width: 312, height: 416, aspectRatio: '3/4' },
  large: { width: 472, height: 629, aspectRatio: '3/4' }
}
// columns 5, aspect ratio 4/3
const IMAGE_SIZES_COLUMNS_5_43 = {
  small: { width: 368, height: 276, aspectRatio: '4/3' },
  medium: { width: 312, height: 416, aspectRatio: '3/4' },
  large: { width: 672, height: 504, aspectRatio: '4/3' }
}
// columns 4, aspect ratio 16/9
const IMAGE_SIZES_COLUMNS_4_169 = {
  small: { width: 336, height: 189, aspectRatio: '16/9' },
  medium: { width: 320, height: 180, aspectRatio: '16/9' },
  large: { width: 368, height: 207, aspectRatio: '16/9' }
}
// columns 4, aspect ratio 4/3
const IMAGE_SIZES_COLUMNS_4_43 = {
  small: { width: 320, height: 240, aspectRatio: '4/3' },
  medium: { width: 333, height: 250, aspectRatio: '4/3' },
  large: { width: 456, height: 342, aspectRatio: '4/3' }
}
// columns 3, aspect ratio 1/1
const IMAGE_SIZES_COLUMNS_3_11 = {
  small: { width: 327, height: 327, aspectRatio: '1/1' },
  medium: { width: 312, height: 312, aspectRatio: '1/1' },
  large: { width: 264, height: 264, aspectRatio: '1/1' }
}
// columns 3, aspect ratio 16/9
const IMAGE_SIZES_COLUMNS_3_169 = {
  small: { width: 327, height: 184, aspectRatio: '16/9' },
  medium: { width: 312, height: 176, aspectRatio: '16/9' },
  large: { width: 264, height: 149, aspectRatio: '16/9' }
}

const IMAGE_SIZES_COLUMNS_5_11 = {
  small: { width: 312, height: 312, aspectRatio: '1/1' },
  medium: { width: 486, height: 486, aspectRatio: '1/1' },
  large: { width: 680, height: 680, aspectRatio: '1/1' }
}

const IMAGE_SIZES_COLUMNS_4_34 = {
  small: { width: 392, height: 294, aspectRatio: '4/3' },
  medium: { width: 552, height: 736, aspectRatio: '3/4' },
  large: { width: 552, height: 736, aspectRatio: '3/4' }
}

const IMAGE_SIZES_COLUMNS_4_11 = {
  small: { width: 334, height: 334, aspectRatio: '1/1' },
  medium: { width: 333, height: 333, aspectRatio: '1/1' },
  large: { width: 456, height: 456, aspectRatio: '1/1' }
}

// columns 3, aspect ratio 1/1
const IMAGE_SIZES_TERMINAL_GRID = {
  small: { width: 312, height: 416, aspectRatio: '3/4' },
  medium: { width: 312, height: 416, aspectRatio: '3/4' },
  large: { width: 264, height: 352, aspectRatio: '3/4' }
}

// columns large: 4, medium: 6, small: 2, aspect ratio 16/9
const IMAGE_SIZES_RELATED_ARTICLES = {
  small: { width: 303, height: 170, aspectRatio: '16/9' },
  medium: { width: 407, height: 229, aspectRatio: '16/9' },
  large: { width: 484, height: 272, aspectRatio: '16/9' }
}

const IMAGE_SIZES_INDEX_REPORTS = {
  small: { width: 533, height: 400, aspectRatio: '4/3' },
  medium: { width: 214, height: 408, aspectRatio: '4/5' },
  large: { width: 336, height: 420, aspectRatio: '4/5' }
}

const IMAGE_SIZES_EVENT_SPEAKERS = {
  small: { width: 327, height: 436, aspectRatio: '3/4' },
  medium: { width: 312, height: 416, aspectRatio: '3/4' },
  large: { width: 368, height: 490, aspectRatio: '3/4' }
}

const IMAGE_SIZES_INDUSTRIES_34 = {
  small: { width: 189, height: 141, aspectRatio: '4/3' },
  medium: { width: 368, height: 490, aspectRatio: '3/4' },
  large: { width: 368, height: 490, aspectRatio: '3/4' }
}

const IMAGE_SIZES_INDUSTRIES_11 = {
  small: { width: 186, height: 186, aspectRatio: '1/1' },
  medium: { width: 364, height: 364, aspectRatio: '1/1' },
  large: { width: 364, height: 364, aspectRatio: '1/1' }
}

const IMAGE_SIZES_PAYMENT_METHODS_COUNTRY_CARD = {
  small: { width: 413, height: 184, aspectRatio: '21/9' },
  medium: { width: 368, height: 328, aspectRatio: '4/3' },
  large: { width: 368, height: 490, aspectRatio: '3/4' }
}

const IMAGE_SIZES_AUTHOR_COMPONENT = {
  small: { width: 48, height: 48, aspectRatio: '1/1' },
  medium: { width: 48, height: 48, aspectRatio: '1/1' },
  large: { width: 48, height: 48, aspectRatio: '1/1' }
}

const UPLIFT_HERO = {
  small: { width: 368, height: 490, aspectRatio: '3/4' },
  medium: { width: 672, height: 'auto', aspectRatio: '3/4' },
  large: { width: 672, height: 896, aspectRatio: '3/4' }
}

const INDEX_REPORTS_LIST = {
  small: { width: 344, height: 258, aspectRatio: '4/3' },
  medium: { width: 214, height: 350, aspectRatio: '107/204' },
  large: { width: 336, height: 420, aspectRatio: '4/5' }
}

const SPOTLIGHT_VIDEO = {
  small: { width: 344, height: 258, aspectRatio: '4/3' },
  medium: { width: 690, height: 388, aspectRatio: '16/9' },
  large: { width: 1200, height: 480, aspectRatio: '5/2' }
}

export default {
  columns12_169: IMAGE_SIZES_COLUMNS_12_169,
  columns12_52: IMAGE_SIZES_COLUMNS_12_52,
  columns12_5269: IMAGE_SIZES_COLUMNS_12_5269,
  columns12_ratio_52_52_169: IMAGE_SIZES_COLUMNS_12_RATIO_52_52_169,
  columns12_21: IMAGE_SIZES_COLUMNS_12_21,
  columns10_21: IMAGE_SIZES_COLUMNS_10_21,
  columns10_169: IMAGE_SIZES_COLUMNS_10_169,
  columns6_11: IMAGE_SIZES_COLUMNS_6_11,
  columns6_43: IMAGE_SIZES_COLUMNS_6_43,
  columns6_34: IMAGE_SIZES_COLUMNS_6_34,
  columns6_ratio_11_52_169: IMAGE_SIZES_COLUMNS_6_RATIO_11_52_169,
  columns6_169: IMAGE_SIZES_COLUMNS_6_169,
  columns5_34: IMAGE_SIZES_COLUMNS_5_34,
  columns5_43: IMAGE_SIZES_COLUMNS_5_43,
  columns5_11: IMAGE_SIZES_COLUMNS_5_11,
  columns4_34: IMAGE_SIZES_COLUMNS_4_34,
  columns4_11: IMAGE_SIZES_COLUMNS_4_11,
  columns4_169: IMAGE_SIZES_COLUMNS_4_169,
  columns4_43: IMAGE_SIZES_COLUMNS_4_43,
  columns3_11: IMAGE_SIZES_COLUMNS_3_11,
  columns3_169: IMAGE_SIZES_COLUMNS_3_169,
  terminals_grid: IMAGE_SIZES_TERMINAL_GRID,
  related_articles: IMAGE_SIZES_RELATED_ARTICLES,
  index_reports: IMAGE_SIZES_INDEX_REPORTS,
  event_speakers: IMAGE_SIZES_EVENT_SPEAKERS,
  industries34: IMAGE_SIZES_INDUSTRIES_34,
  industries11: IMAGE_SIZES_INDUSTRIES_11,
  payment_methods_country_card: IMAGE_SIZES_PAYMENT_METHODS_COUNTRY_CARD,
  hero: UPLIFT_HERO,
  author_component: IMAGE_SIZES_AUTHOR_COMPONENT,
  index_list: INDEX_REPORTS_LIST,
  spotlight_video: SPOTLIGHT_VIDEO
}
